/**
 * Formats a date string as M/D/YYYY (e.g. 12/24/2026).
 * @param dateStr - ISO or parseable date string
 * @returns Formatted date string, or original string if invalid
 */
export function formatDateMMDDYYYY(dateStr: string): string {
  const date = new Date(dateStr);
  if (Number.isNaN(date.getTime())) return dateStr;
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const year = date.getFullYear();
  return `${month}/${day}/${year}`;
}
